import * as Yup from "yup";

const validationSchema = Yup.object({
  email: Yup.string().required("Invalid Email!"),
});

export default validationSchema;
